import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["error", "id", "name", "defaultValue", "value", "onChange", "disabled", "label", "placeholder", "hintMessage", "maxLength", "bgColor", "autoComplete"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/InputPassword/InputPassword.js",
  _this = this;
import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { noop } from '../../helpers';
import { Hide as HideIcon, Show as ShowIcon } from '@dls/assets/icons';
import FormField from '../../core/components/Forms/FormField';
import FormInput from '../../core/components/Forms/FormInput';
import HintText from '../../core/components/Forms/HintText';
import FormFieldHint from '../../core/components/Forms/FormFieldHint';
import LabelText from '../../core/components/Forms/LabelText';
import { useTheme } from '../../core/ThemeProvider';
var InputPassword = function InputPassword(props) {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    toggle = _useState2[0],
    setToggle = _useState2[1];
  var onToggleView = useCallback(function () {
    return setToggle(function (toggle) {
      return !toggle;
    });
  }, []);
  var handleMouseDown = useCallback(function (e) {
    // TODO Test preventDefault was fired..

    /**
     * Cannot make assertions.
     * Something under the hood is stopping the mock `preventDefault`
     * function to be passed down to the callback.
     * */
    e.preventDefault();
  }, []);
  var error = props.error,
    id = props.id,
    name = props.name,
    defaultValue = props.defaultValue,
    value = props.value,
    onChange = props.onChange,
    disabled = props.disabled,
    label = props.label,
    placeholder = props.placeholder,
    hintMessage = props.hintMessage,
    maxLength = props.maxLength,
    bgColor = props.bgColor,
    autoComplete = props.autoComplete,
    rest = _objectWithoutProperties(props, _excluded);
  var _useTheme = useTheme(),
    theme = _useTheme.theme;
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(FormField, {
    disabled: disabled,
    defaultValue: defaultValue || value,
    error: error,
    bgColor: bgColor,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(InputContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormInput, {
    "data-testid": "inputField",
    id: id,
    name: name,
    placeholder: placeholder || ' ',
    error: error,
    type: toggle ? 'password' : 'text',
    onChange: onChange,
    value: value,
    maxLength: maxLength,
    defaultValue: defaultValue,
    autoComplete: autoComplete,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(LabelText, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 9
    }
  }, label), /*#__PURE__*/React.createElement(InputAdornment, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(IconHotSpot, {
    onMouseDown: handleMouseDown,
    onClick: onToggleView,
    "data-testid": "toggleView",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 11
    }
  }, toggle ? /*#__PURE__*/React.createElement(HideIcon, {
    size: 24,
    color: theme.cl_sec_d1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 15
    }
  }) : /*#__PURE__*/React.createElement(ShowIcon, {
    size: 24,
    color: theme.cl_sec_d1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 15
    }
  })))), hintMessage && /*#__PURE__*/React.createElement(FormFieldHint, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(HintText, {
    mt: 3,
    error: error,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 11
    }
  }, hintMessage)));
};
InputPassword.defaultProps = {
  disabled: false,
  error: false,
  onChange: noop,
  bgColor: 'white'
};
var InputContainer = styled.div.withConfig({
  displayName: "InputPassword__InputContainer",
  componentId: "sc-2mwtbe-0"
})(["padding-right:40px;"]);
var IconHotSpot = styled.div.withConfig({
  displayName: "InputPassword__IconHotSpot",
  componentId: "sc-2mwtbe-1"
})(["display:inline-block;cursor:pointer;padding:8px;line-height:0;"]);
var InputAdornment = styled.div.withConfig({
  displayName: "InputPassword__InputAdornment",
  componentId: "sc-2mwtbe-2"
})(["position:absolute;right:16px;top:0;height:100%;display:flex;flex-direction:column;justify-content:center;z-index:1;"]);
export default InputPassword;